import React from 'react';
import { FiExternalLink, FiVideo, FiPackage, FiDollarSign, FiTag, FiGift } from 'react-icons/fi';

const WhatnotLink: React.FC = () => {
  return (
    <div className="my-8 mx-auto max-w-4xl">
      <div className="mb-6">
        <h2 className="text-2xl font-bold">Our Whatnot Streams</h2>
        <p className="text-gray-300 mt-2">Check out our live auctions and exclusive drops</p>
      </div>
      
      <div className="bg-gradient-to-r from-purple-900 to-indigo-900 rounded-lg border border-gray-800 p-6 shadow-lg hover:shadow-xl transition-all">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0">
            <div className="flex items-center mb-3">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse mr-2"></div>
              <span className="font-medium text-red-400">LIVE AUCTIONS</span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-2">Grailed804 on Whatnot</h3>
            
            <div className="flex flex-wrap gap-4 mb-4">
              <div className="flex items-center">
                <div className="flex items-center justify-center h-8 w-8 rounded-full bg-accent/20 text-accent mr-2">
                  <FiVideo className="h-4 w-4" />
                </div>
                <span>Live Streams</span>
              </div>
              <div className="flex items-center">
                <div className="flex items-center justify-center h-8 w-8 rounded-full bg-accent/20 text-accent mr-2">
                  <FiGift className="h-4 w-4" />
                </div>
                <span>Exclusive Drops</span>
              </div>
              <div className="flex items-center">
                <div className="flex items-center justify-center h-8 w-8 rounded-full bg-accent/20 text-accent mr-2">
                  <FiDollarSign className="h-4 w-4" />
                </div>
                <span>$1 Auctions</span>
              </div>
              <div className="flex items-center">
                <div className="flex items-center justify-center h-8 w-8 rounded-full bg-accent/20 text-accent mr-2">
                  <FiTag className="h-4 w-4" />
                </div>
                <span>Steals & Deals</span>
              </div>
            </div>
          </div>
          
          <a 
            href="https://www.whatnot.com/user/grailed804" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-accent text-white rounded-lg hover:bg-accent/90 transition-all shadow-lg"
          >
            <span className="mr-2">Visit Whatnot</span>
            <FiExternalLink />
          </a>
        </div>
      </div>
    </div>
  );
};

export default WhatnotLink; 